import { createPopper } from '@popperjs/core';
/*
Vue component called on single watch page. Used to show tooltip (product name)
on strap alternatives, and show product price in local currency (getPrice function listen in 
twig template directly)
*/
function initWatch()
{
  if (!$("#single-watch").length || typeof app_data === "undefined") {
    return false;
  }


  new Vue({
    el: '#single-watch',
    delimiters: ['[[',']]'],

    data: app_data,
    computed : {
      watchStatus : function()
      {
        return (this.isAdded) ? "is-added" : "not-added";
      }

    },
    methods:
    {

      hideStickyHeader : function()
      {
        document.getElementById("header").classList.remove("scrolled");
      },


      setBgImage: function ( card )
      {
        if (typeof card !== 'undefined') {
          let src = ( window.devicePixelRatio < 1.5 ) ? card.image : card.medium_image;
          return 'background-image:url('+src+')';
        }
      },


      scrollTo : function(element_id)
      {
        $([document.documentElement, document.body]).animate({
            scrollTop: $( element_id ).offset().top-140
        }, 1000);
      },


      getPrice: function()
      {
        if ( !this.pricesVisible || document.getElementById('casebackOptionsModal') ) {
          this.pricesVisible = false;
          this.isXhr = true;
          let request_data = {
            action :  "get_price_by_cc",
            pid : this.id
          };

          if ( this.countryCode ) {
            request_data.cc = this.countryCode;
          }

          // console.log("get price...");
           // console.log(request_data);
          $.ajax(
          {
            url: xhrUrl,
            type: 'GET',
            data: request_data,
            dataType: 'JSON',
            success: this.getPrice_ajaxCallback,
            error: this.getPrice_ajaxCallback
          });
        } else {
          this.pricesVisible = false;
          this.isXhr = false;
        }

      },


      getPrice_ajaxCallback : function(response)
      {
        this.isXhr = false;
        if ( typeof response === "object" && response.status === "ok" && typeof response.prices === "object" && response.prices !== null ) { 
          this.prices = response.prices;
          this.pricesVisible = true;
        } else {
          this.prices = 'on-request';
          this.pricesVisible = true;          
        }
      },

      forceUpdate : function() {
        this.$forceUpdate();
      }

    },
    created: function(){
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    }
  });

}

export { initWatch };